module.exports = __webpack_public_path__ + "static/media/29.e1e8df96.jpg";